"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContainer = exports.Compose = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Simple component that composes components together.
 */
function Compose(props) {
    var _a = props.components, components = _a === void 0 ? [] : _a, children = props.children;
    return (react_1.default.createElement(react_1.default.Fragment, null, components.reduceRight(
    // eslint-disable-next-line @typescript-eslint/naming-convention
    function (acc, Component) { return (react_1.default.createElement(Component, null, acc)); }, children)));
}
exports.Compose = Compose;
/**
 * Create a container component that composes all of the sub-components together.
 */
function createContainer(providers) {
    return function (props) {
        var children = props.children;
        return react_1.default.createElement(Compose, { components: providers }, children);
    };
}
exports.createContainer = createContainer;
